<template>
  <div class="d-flex-column justify-start align-start achievement_card gap-18">
    <div class="d-flex-row justify-start gap-15">
      <img
        :src="achievementData?.game?.image"
        alt="Game icon"
        height="36"
        width="36"
        style="border-radius: 5.4px"
      />
      <h5 class="t-white regular-xl f-w-700 font-family-2">
        {{ achievementData?.game?.short_title }}
      </h5>
    </div>
    <hr class="horizontal" style="background-color: #17181a" />
    <div class="d-flex-column justify-start align-start gap-15">
      <div
        class="d-flex-row justify-start"
        v-for="achievement in achievementData?.achievements"
        :key="achievement"
      >
        <img
          :src="achievement.icon"
          alt="Achivement icon"
          height="36"
          width="36"
          style="object-fit: contain"
        />
        <div class="d-flex-column align-start gap-0">
          <h5 class="regular-l f-w-700 t-white font-family-2">
            {{ achievement?.title }}
          </h5>
          <p class="regular-m t-light font-family-2">
            {{ achievement?.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    achievementData: {
      default: {},
    },
  },

  computed: {},
};
</script>
